var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('router-view'),_c('users')],1)}
var staticRenderFns = []

export { render, staticRenderFns }